import { render, staticRenderFns } from "./PageMobileMenuButton.vue?vue&type=template&id=6c84dae4&"
import script from "./PageMobileMenuButton.vue?vue&type=script&lang=js&"
export * from "./PageMobileMenuButton.vue?vue&type=script&lang=js&"
import style0 from "./PageMobileMenuButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemContent,VListItemTitle})
